module.exports = __webpack_public_path__ + "img/GBM1_DC.9ba5e22d.png";